import type {
  PixiAddress,
  PixiPaymentMethod,
} from "../../hooks/usePixiWizardState";

/**
 * MOCK of the Payment & Shipping step's output (signage-next-frontend#13423).
 * That step is still a stub on `main`, so until it lands the Checkout review
 * card has no real `billingAddress`/`shippingAddress`/`paymentMethod` to show.
 * These fallbacks mirror #13423's `PixiAddress`/`PixiPaymentMethod` interface so
 * the only swap-point when step 3 ships is removing the `?? MOCK_*` fallbacks in
 * CheckoutStep — the card itself stays the same.
 */
export const MOCK_BILLING_ADDRESS: PixiAddress = {
  firstName: "Alex",
  secondName: "Morgan",
  company: "ScreenCloud",
  email: "alex.morgan@example.com",
  phone: "+1 415 555 0142",
  country: "United States",
  state: "California",
  street: "Market Street",
  building: "1355",
  city: "San Francisco",
  postalCode: "94103",
};

export const MOCK_SHIPPING_ADDRESS: PixiAddress = {
  firstName: "Alex",
  secondName: "Morgan",
  company: "ScreenCloud",
  email: "alex.morgan@example.com",
  phone: "+1 415 555 0142",
  country: "United States",
  state: "",
  street: "Market Street",
  building: "1355",
  city: "San Francisco",
  postalCode: "94103",
};

export const MOCK_PAYMENT_METHOD: PixiPaymentMethod = "credit_card";
